module.exports = {
  lib: require('./emojis'),
  ordered: require('./ordered'),
  fitzpatrick_scale_modifiers: ["🏻", "🏼", "🏽", "🏾", "🏿"]
}
